<template>
    <div class="row">
        <div class="card-box-custom col-xl-3 col-lg-4 mb-4 mb-xl-0">
            <div
                class="card text-primary text-center p-4"
                :class="[
                    { 'cursor-pointer': subscription.isCurrentTariff },
                    { 'pe-none': !subscription.isCurrentTariff }
                ]"
                @click="goToSubscription"
            >
                <div v-text="subscriptionCard.label" class="mb-3 text-sm" />
                <h4
                    v-text="subscriptionCard.value"
                    class="align-self-center text-dark font-weight-medium mb-0"
                />
            </div>
        </div>
        <div class="col mb-4 mb-xl-0">
            <div class="card">
                <div class="row row-cols-sm-3 row-cols-1">
                    <div
                        v-for="(card, idx) in summaryCards"
                        :key="idx"
                        class="col summary-card text-primary text-center"
                    >
                        <div v-text="card.label" class="mb-3" />
                        <div class="d-flex justify-content-center">
                            <img
                                class="mr-3"
                                :src="require(`@/assets/img/drs/${card.img}`)"
                            />
                            <h3
                                v-text="`${card.count} / ${card.total}`"
                                class="align-self-center text-dark font-weight-medium mb-0"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DEVICE_TYPES } from '@/utils/constants/drs/store-devices.js'

export default {
    name: 'SummaryCards',
    props: {
        subscription: {
            type: Object,
            default: () => ({})
        },
        isExpiringSubscription: {
            type: Boolean,
            default: false
        },
        subscriptionType: {
            type: String,
            default: 'current'
        }
    },
    methods: {
        goToSubscription() {
            if (!this.subscription.isCurrentTariff) return

            this.$store.dispatch('openModal', {
                componentPath: 'drs/configuration/TariffPreview',
                args: { tariff_id: this.subscriptionCard.tariff_id }
            })
        }
    },
    computed: {
        ...mapGetters('drsLicenses', ['deviceSummary']),

        summaryCards() {
            const subs = this.subscription.device_type_subscriptions || []
            const deviceTypeMap = Object.fromEntries(
                subs.map(sub => [sub.device_type, sub.amount])
            )

            return DEVICE_TYPES.map(el => {
                const { count = 0 } = this.deviceSummary[el.id] || {}
                const total = deviceTypeMap[el.device_type_subscriptions] || 0

                return { ...el, count, total }
            })
        },
        subscriptionCard() {
            const { tariff_name, tariff_id } = this.subscription || {}

            const month = this.subscriptionType === 'current' ? '(przyszły msc.)' : '(aktualny msc.)'
            const label = this.isExpiringSubscription
                ? 'Twój pakiet ' + month
                : 'Twój pakiet'

            return {
                id: 'package',
                label,
                value: tariff_name || '---',
                tariff_id
            }
        }
    }
}
</script>